<template>
    <div v-if="users">
        <div v-if="users.length === 0">User tidak ditemukan</div>

        <v-simple-table v-else>
            <thead>
                <tr>
                    <th>Nama</th>
                    <th>Email</th>
                    <th>Kontak</th>
                    <th>Tipe Ujian</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="user in users"
                    :key="user.id"
                >
                    <td>
                        {{ user.name }}
                    </td>
                    <td>
                        {{ user.email }}
                    </td>
                    <td>
                        {{ user.contact }}
                    </td>
                    <td>
                        {{ user.university }}
                    </td>
                    <td>
                        <v-btn
                            @click="$refs.changePassword.show(user)"
                            color="primary"
                            icon
                        >
                            <v-icon>mdi-key-variant</v-icon>
                        </v-btn>

                        <v-btn
                            @click="$refs.period.show(user)"
                            color="primary"
                            icon
                        >
                            <v-icon>mdi-file</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <change-password-dialog ref="changePassword"></change-password-dialog>
        <period-dialog ref="period"></period-dialog>
    </div>
</template>

<script>
import ChangePasswordDialog from './ChangePasswordDialog.vue'
import PeriodDialog from './PeriodDialog.vue'

export default {
    props: {
        users: {
            type: Array,
        },
    },

    components: {
        ChangePasswordDialog,
        PeriodDialog,
    },
}
</script>
